import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';
import ROUTE from '@app/navigationApp/routes';
import { formatIndianCurrency } from '@app/utils/utility';
import { Info } from '@app/sharedComponents/Icons/Icons';
import { LENDER_ID } from '@app/types/regix';

const LoanExpiryCard = ({creditInfo,daysToRenewal,navigation}) => {
    const {principalOutStandingAmount,actualLoanAmount} = creditInfo;
    const title = ()=>{
      if(daysToRenewal==1 ){
        return 'Loan expiring today, 5 PM'
      } else if(daysToRenewal==2 ){
        return 'Loan will expire tomorrow, 5 PM'
      } else{
        return `Your loan will expire in ${daysToRenewal} day${daysToRenewal>1 && 's'}!`
      }
    }
    const heading = title();
    const displayAmount = principalOutStandingAmount > 0 ? principalOutStandingAmount:actualLoanAmount;
    return(
    <ThemedView mx='lg' p='lg' mt='2xl'  borderColor='border-primary' backgroundColor='bg-surface-primary' borderWidth={1} borderRadius='lg'>
        <ThemedView flexDirection='row' mb='lg' alignItems='center'>
            <WarningCircle size={25} weight="fill" color='#DE4043'/>
        <ThemedText color='text-primary' ml='sm' variant='h5s'>
          {/* Loan expiring today, 5 PM */}
          {heading}
        </ThemedText>
        </ThemedView>

        <ThemedText color='text-secondary' mb='2xs' variant='b4r' >
          {principalOutStandingAmount >0 ?'Outstanding amount':'Credit limit'}
        </ThemedText>
        <ThemedView flexDirection='row' alignItems='center' mb='lg'>
        <ThemedText color={principalOutStandingAmount >0 ?'text-error':'text-primary'} variant='l1'>
          ₹
        </ThemedText>
        <ThemedText color={principalOutStandingAmount >0 ?'text-error':'text-primary'} variant='h1b'>
          {formatIndianCurrency(displayAmount)}
        </ThemedText>
        </ThemedView>

        <ThemedView backgroundColor='bg-fill-info' p='sm' flexDirection='row' alignItems='center' borderRadius='sm' mb='md'>
        <Info weight="fill" color={themeColorSet['icon-secondary']} size={16}/>
          <ThemedText variant='b4m' color='text-secondary' ml="sm">
              {principalOutStandingAmount >0 ? 'Please clear all dues before expiry to avoid portfolio sell-off. ' : 'What happens if i do not renew? '}
          <ThemedPressable onPress={()=>{navigation?.navigate(ROUTE.RENEWAL_LEARN_MORE)}}>
          <ThemedText variant='b4b' color='text-action-primary'>
            Learn more
          </ThemedText>
          </ThemedPressable>
          </ThemedText>
          
        </ThemedView>
        <Button label='Renew loan' size="MD" type='SOLID' handlePress={()=>{navigation?.navigate(ROUTE.RENEW_LOAN,{daysToRenewal})}}/>
    </ThemedView>
    )
}

export default LoanExpiryCard;